import { tokens } from '@fluentui/react-components';

/**
 * Every page's root: one column of sections at the FULL content width, with the same gap and padding on every page
 * (Christian's bar, 2026-10-28: "a pleasure to navigate", full-width content, consistent spacing).
 *
 * Pages used to cap themselves at 900–1400px and centre. On a 1920px screen that left ~300px of empty margin while
 * client names wrapped and the Clients table cut its Notes column off. A page whose CONTENT needs a reading measure
 * (prose) lays its sections out in a grid instead of narrowing the page; `fullWidthGuard.test.ts` keeps the caps out.
 *
 * Spread it into a makeStyles rule: `page: { ...pageShell }`.
 */
export const pageShell = {
  display: 'flex',
  flexDirection: 'column',
  gap: tokens.spacingVerticalL,
  padding: tokens.spacingVerticalL,
  width: '100%',
} as const;
